import { useMemo } from "react";
import { SelectField } from "@/components/common";
import { useTran } from "@/hooks";

/**
 * Source filter — overview-only. Distinguishes manual entries from NxMap
 * imports and computed disclosures. Meaningless after consolidation
 * (post-aggregation, source is mixed by definition), so the consolidated
 * filter bar does NOT compose this.
 */
const ALL = "__all__";

const SourceFilter = ({ value, onChange }) => {
  const { t } = useTran();
  const options = useMemo(
    () => [
      { value: ALL, label: t("All Metric Types") },
      { value: "manual", label: t("Manual") },
      { value: "nxmap", label: t("NXMap") },
      { value: "computed", label: t("Computed") },
    ],
    [t],
  );

  return (
    <SelectField
      label={t("Metric Type")}
      options={options}
      value={value || ALL}
      onValueChange={(v) => onChange(v === ALL ? "" : v)}
      sortOptions={false}
      placeholder={t("All Metric Types")}
      className="w-full sm:w-40"
    />
  );
};

export default SourceFilter;
